// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

const KICKER = `font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:var(--ink-4)`;
const FIELD = `height:30px;padding:0 10px;border:1px solid #C8D4EA;border-radius:8px;font-family:inherit;font-size:12.5px;color:var(--ink);background:#fff;outline:none;box-sizing:border-box`;
const PILL = `flex:none;height:28px;padding:0 12px;border-radius:999px;border:1px solid #C8D4EA;background:#fff;font-family:inherit;font-size:12px;color:var(--ink-2);cursor:pointer`;
const DANGER = `flex:none;height:28px;padding:0 12px;border-radius:999px;border:1px solid #E5484D;background:#E5484D;font-family:inherit;font-size:12px;color:#fff;cursor:pointer`;
const PRIMARY = `flex:none;height:28px;padding:0 12px;border-radius:999px;border:1px solid #0052CD;background:#0052CD;font-family:inherit;font-size:12px;color:#fff;cursor:pointer`;
const ROW = `display:flex;align-items:center;gap:12px;min-height:48px;padding:8px 16px;border-top:1px solid #EDF1F8`;

function Editor({ r }) {
  return (
    <div style={sx(`flex:1;min-width:0;display:flex;flex-direction:column;gap:4px`)}>
      <div style={sx(`display:flex;align-items:center;gap:8px`)}>
        <input
          className="gmFocus"
          autoFocus
          aria-label={`New name for ${r.name}`}
          value={r.draft}
          maxLength={200}
          disabled={r.busy}
          onChange={r.onDraft}
          onKeyDown={r.onKey}
          style={sx(`${FIELD};flex:1;min-width:0;max-width:420px`)}
        />
        <button type="button" onClick={r.onSave} disabled={!r.canSave} aria-label="Save new name" style={sx(`${PRIMARY};opacity:${r.canSave ? 1 : 0.5};cursor:${r.canSave ? 'pointer' : 'default'}`)}>
          {r.busy ? 'Saving…' : 'Save'}
        </button>
        <button type="button" onClick={r.onCancel} disabled={r.busy} style={sx(PILL)}>
          Cancel
        </button>
      </div>
      {r.error ? <div style={sx(`font-size:11.5px;color:#E5484D`)}>{r.error}</div> : null}
    </div>
  );
}

function Row({ r }) {
  if (r.editing) {
    return (
      <div style={sx(ROW)}>
        <Editor r={r} />
      </div>
    );
  }
  return (
    <div style={sx(`${ROW};${r.asking ? 'background:#FFF6F6' : ''}`)}>
      <div style={sx(`flex:1;min-width:0;display:flex;flex-direction:column;gap:2px`)}>
        <div style={sx(`display:flex;align-items:center;gap:8px;min-width:0`)}>
          <span title={r.name} style={sx(`font-size:13px;color:var(--ink);overflow:hidden;text-overflow:ellipsis;white-space:nowrap`)}>{r.name}</span>
          {r.current ? (
            <span style={sx(`flex:none;font-size:10px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;padding:2px 7px;border-radius:4px;background:#EAF1FD;color:#0052CD`)}>Open</span>
          ) : null}
        </div>
        {r.asking ? (
          <span style={sx(`font-size:12px;color:#B42318`)}>{r.deleteMsg}</span>
        ) : r.meta ? (
          <span style={sx(`font-size:11.5px;color:var(--ink-4)`)}>{r.meta}</span>
        ) : null}
      </div>
      {r.asking ? (
        <span style={sx(`flex:none;display:flex;align-items:center;gap:8px`)}>
          <button type="button" onClick={r.onConfirmDelete} disabled={r.busy} style={sx(DANGER)}>
            {r.busy ? 'Deleting…' : 'Delete'}
          </button>
          <button type="button" onClick={r.onCancel} disabled={r.busy} style={sx(PILL)}>
            Cancel
          </button>
        </span>
      ) : (
        <span style={sx(`flex:none;display:flex;align-items:center;gap:8px`)}>
          {r.canRename ? (
            <button type="button" className="gmHover" onClick={r.onRename} aria-label={`Rename ${r.name}`} style={sx(PILL)} data-hover="border-color:#0052CD;color:#0052CD">
              Rename
            </button>
          ) : null}
          {r.canDelete ? (
            <button type="button" className="gmHover" onClick={r.onDelete} aria-label={`Delete ${r.name}`} style={sx(PILL)} data-hover="border-color:#E5484D;color:#E5484D">
              Delete
            </button>
          ) : null}
        </span>
      )}
    </div>
  );
}

function Section({ s }) {
  return (
    <section aria-label={s.title} style={sx(`border:1px solid #DCE4F2;border-radius:10px;background:#fff;overflow:hidden`)}>
      <div style={sx(`display:flex;align-items:baseline;gap:10px;padding:14px 16px 10px`)}>
        <h3 style={sx(`margin:0;font-size:13.5px;font-weight:500;color:var(--ink)`)}>{s.title}</h3>
        <span style={sx(`font-size:11.5px;color:var(--ink-4)`)}>{s.count}</span>
        <span style={sx(`margin-left:auto;font-size:11.5px;color:var(--ink-4)`)}>{s.note}</span>
      </div>
      {s.rows.length ? (
        s.rows.map((r) => <Row key={r.key} r={r} />)
      ) : (
        <div style={sx(`padding:14px 16px;border-top:1px solid #EDF1F8;font-size:12.5px;color:var(--ink-3)`)}>{s.empty}</div>
      )}
    </section>
  );
}

export default function VersionManagementScreen({ vm }: { vm: any }) {
  if (!vm.showVersions || !vm.versionManagement) return null;
  const view = vm.versionManagement;
  return (
    <div data-testid="gm-version-management" style={sx(`flex:1;min-height:0;overflow:auto;display:flex;flex-direction:column;gap:16px;padding:22px 24px 24px`)}>
      <div style={sx(`display:flex;align-items:baseline;gap:12px`)}>
        <div style={sx(KICKER)}>Version Management</div>
        {view.hasNote ? <span style={sx(`font-size:12.5px;color:var(--ink-3)`)}>{view.note}</span> : null}
      </div>
      {view.sections.map((s) => (
        <Section key={s.id} s={s} />
      ))}
    </div>
  );
}
